export default __webpack_public_path__ + "static/media/cloud-two.f8f6a376.svg";